import type { EditOrderFormInputs } from '@src/orders/schemas/EditOrderFormInputs';
import { createContext } from 'react';

interface OrderValuesContextProps {
  values: EditOrderFormInputs;
  setValues: (defaultValues: EditOrderFormInputs) => void;
}

export const OrderValuesContext = createContext<
  OrderValuesContextProps | undefined
>(undefined);
